import i18next from 'i18next'

import { PASSWORD_LENGTH } from 'config'

export const getServerErrorMessage = (errorCode: string | number) => {
  const errors = {
    '-2': i18next.t('server_error.-2'),
    '-4': i18next.t('server_error.-4'),
    '-5': i18next.t('server_error.-5'),
    '-6': i18next.t('server_error.-6'),
    '-7': i18next.t('server_error.-7'),
    '-8': i18next.t('server_error.-8'),
    '-11': i18next.t('server_error.-11'),
    '-12': i18next.t('server_error.-12'),
    '-15': i18next.t('server_error.-15'),
    '-16': i18next.t('server_error.-16'),
    '-103': i18next.t('server_error.-103'),
    '-20': i18next.t('server_error.-20'),
    '-21': i18next.t('server_error.-21'),
    '-26': i18next.t('server_error.-26'),
    '-200': i18next.t('server_error.-200'),
    '-201': i18next.t('server_error.-201'),
    '-202': i18next.t('server_error.-202'),
    '-203': i18next.t('server_error.-203'),
    '-308': i18next.t('server_error.-308'),
    '-312': i18next.t('server_error.-312'),
    '-319': i18next.t('server_error.-319'),
    '-320': i18next.t('server_error.-320'),
    '-321': i18next.t('server_error.-321'),
    '-326': i18next.t('common.eligible_for_only_vip'),
    '-331': i18next.t('server_error.-331'),
    '-334': i18next.t('server_error.-334'),
    '-335': i18next.t('server_error.-335'),
    '-338': i18next.t('server_error.-338'),
    '-340': i18next.t('server_error.-340'),
    '-343': i18next.t('server_error.-343'),
    '-347': i18next.t('server_error.-347'),
    '-348': i18next.t('server_error.-348'),
    '-350': i18next.t('server_error.-350'),
    '-355': i18next.t('server_error.-355'),
    '-356': i18next.t('server_error.-356'),
    '-363': i18next.t('server_error.-363'),
    '-367': i18next.t('server_error.-367'),
    '-367-create-chat': i18next.t('server_error.-367-create-chat'),
    '-369': i18next.t('server_error.-369'),
    '-370': i18next.t('server_error.-370'),
    '-374': i18next.t('server_error.-374'),
    '-375': i18next.t('server_error.-375'),
    '-376': i18next.t('server_error.-376'),
    '-382': i18next.t('server_error.-382'),
    '-383': i18next.t('server_error.-383'),
    '-385': i18next.t('server_error.-385'),
    '-398': i18next.t('server_error.-398'),
    '-402': i18next.t('server_error.-402'),
    '-403': i18next.t('server_error.-403'),
    '-404': i18next.t('server_error.-404'),
    '-405': i18next.t('server_error.-405'),
    '-406': i18next.t('server_error.-406'),
    '-421': i18next.t('server_error.-421'),
    '-977': i18next.t('server_error.-977'),
    429: i18next.t('server_error.429'),
    '404-wrong-verification-code': i18next.t(
      'server_error.404-wrong-verification-code'
    ),
    '-407': i18next.t('server_error.-407', {
      min: PASSWORD_LENGTH.MIN,
      max: PASSWORD_LENGTH.MAX,
    }),
    '-408': i18next.t('server_error.-408', {
      min: PASSWORD_LENGTH.MIN,
      max: PASSWORD_LENGTH.MAX,
    }),
    '-409': i18next.t('server_error.-409'),
    '-410': i18next.t('server_error.-410'),
    '404': i18next.t('server_error.-5'),
    '404-group-not-found': i18next.t('server_error.404-group-not-found'),
    '-416': i18next.t('server_error.-416'),
  }

  return errors[errorCode?.toString()] ?? i18next.t('server_error.unknown')
}

export const getServerErrorTitle = (errorCode: string | number) => {
  const errors = {
    '-409': i18next.t('server_error_title.-409'),
    '-410': i18next.t('server_error_title.-410'),
  }

  return errors[errorCode?.toString()] ?? ''
}
